import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { selectQuickQuote, selectShipmentEditorValid } from '../../../store/shipment-editor/shipment-editor.state';
import { shipmentEditorSetMode } from '../../../store/shipment-editor/shipment-editor.actions';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-shipment-mode',
    templateUrl: './shipment-mode.component.html',
    styleUrls: ['./shipment-mode.component.scss'],
    imports: [MatSlideToggle, AsyncPipe]
})
export class ShipmentModeComponent implements OnInit {

  constructor(private store: Store<AppState>) { }

  display$: Observable<boolean>;
  quickQuoteMode$: Observable<boolean>;

  ngOnInit(): void {
    this.display$ = this.store.select(selectShipmentEditorValid);
    this.quickQuoteMode$ = this.store.select(selectQuickQuote);
  }

  toggled(value: boolean): void {
    this.store.dispatch(shipmentEditorSetMode({ quickQuote: value }));
  }

}
